import request from "../utils/request";

export const get = (type) => request.get(`/api/document/${type}`);
export const create = (data) => request.post("/api/document", data);
